import { Grid2 as Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "../../common";

type ManageCardsToolbarProps = {
  handleCreate?: () => void;
  label?: string;
};

export const ManageCardsToolbar = ({
  handleCreate,
  label = "Add Card",
}: ManageCardsToolbarProps) => {
  return (
    <Grid container size={12}>
      <Grid
        size="grow"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button
          label={label}
          variantType="primary"
          icon={AddIcon}
          sx={{
            textTransform: "capitalize !important",
            whiteSpace: "nowrap",
            width: "auto !important",
            minWidth: "fit-content",
            flexShrink: 0,
            px: 2,
          }}
          onClick={handleCreate}
        />
      </Grid>
    </Grid>
  );
};
